
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30982',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30982",
  "emoji-mart": "static-3.6",
  "feedback-schema": "static-1.55560",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8491",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11945",
  "I18n": "static-7.1703",
  "quartz": "static-1.7632",
  "quartz-config": "static-1.1410",
  "quartz-core": "static-1.6851",
  "react-dlb": "static-1.93",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.84",
  "reselect": "static-3.16",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1075",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55547",
  "feedback-utils": "static-1.55551",
  "forms-embed-utils-lib": "static-1.4916",
  "forms-utils-lib": "static-1.13299",
  "foundations-assets": "static-1.5339",
  "foundations-components": "static-1.8706",
  "foundations-theming": "static-1.4942",
  "hub-http": "static-1.6662",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12252",
  "icons": "static-2.700",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4220",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1-use-beacon-keepalive-queue.3",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5645",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.516",
  "tinymce-plugins": "static-1.58467",
  "transmute": "static-2.97",
  "ui-images": "static-2.1273",
  "UIComponents": "static-3.8891",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3909",
  "quartz-webpack": "static-1.3856",
  "foundations-theming-specialty": "static-1.2658",
  "property-description-translator": "static-1.4272",
  "HeadJS": "static-2.817",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3602",
  "msw": "static-1.102",
  "msw-config": "static-1.25",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.95",
  "jasmine": "static-4.4762",
  "jasmine-runner": "static-1.6903",
  "opentelemetry-fe-types": "static-1-unrevert-default-instrumentation.4",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.904",
  "hubspotter-http": "static-1.4965",
  "mobile-manifest-mixins": "static-1.601",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1-unrevert-default-instrumentation.4",
  "quartz-auth": "static-1.1307",
  "quartz-head": "static-1.1297",
  "quartz-i18n": "static-1.1307",
  "quartz-routing": "static-1.1062",
  "quartz-test": "static-1.1307",
  "quartz-tracking": "static-1.1011",
  "trellis-components": "static-1.3049",
  "ui-fonts": "static-1.1207",
  "usage-tracker-container": "static-1.7765",
  "usage-tracker-core": "static-1.7625",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.341",
  "conversations-skeleton-state": "static-1.7604",
  "reference-resolvers": "static-1.8633",
  "sanitize-text": "static-1.8610",
  "PatternValidationJS": "static-1.3339",
  "ReduxMessenger": "static-2.10822",
  "outpost": "static-1.4584",
  "rpc-client-utils": "static-1.5126",
  "sanitize": "static-1.4927",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4975",
  "floating-ui": "static-1.67",
  "hs-story-utils": "static-1.9878",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.98",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.3030",
  "bend-plugin-foundations-theming": "static-1.3425",
  "foundations-theming-base": "static-1.3927",
  "stylex": "static-1.46",
  "hs-locale-management": "static-1.390",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.152",
  "web-vitals": "static-1.19",
  "ai-components-ui-library": "static-1.9975",
  "atom": "static-1.5529",
  "codemirror": "static-5.106",
  "content-assistance-lib": "static-1.8388",
  "ContentUtils": "static-1.69422",
  "data-token-picker": "static-1.17092",
  "file-manager-components": "static-1.24795",
  "FileManagerCore": "static-1.40294",
  "FileManagerLib": "static-1.40435",
  "frontend-preferences-client": "static-1.8371",
  "hub-http-contrib": "static-1.3483",
  "interframe": "static-3.5195",
  "layout-dnd-components": "static-1.13185",
  "layout-dnd-utils": "static-1.12160",
  "property-translator": "static-1.5832",
  "react-codemirror": "static-1.11093",
  "react-colorpicker": "static-2.10664",
  "reference-resolvers-lite": "static-1.8560",
  "rich-text-lib": "static-1.20516",
  "tinymce-data": "static-1.41438",
  "tinymce-themes": "static-1.57323",
  "ui-addon-emoji-picker": "static-1.10317",
  "ui-addon-sales-email": "static-1.5655",
  "ui-brand-identity-lib": "static-1.16897",
  "bender-build-tools": "static-1.3553",
  "opentelemetry-web": "static-1.22",
  "hub-http-shared-msw-handlers": "static-1.10861",
  "hubspotter-http-shared-msw-handlers": "static-1.10859",
  "usage-tracker-session-replay": "static-1.5461",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1443",
  "tanstack-virtual": "static-1.42",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.536",
  "chirp-fetch": "static-1.2356",
  "stylex-utils": "static-1.170",
  "chatspot-core": "static-1.23708",
  "copilot-toolkit": "static-1.12103",
  "customer-data-objects-ui-components": "static-1.13483",
  "data-fetching-client": "static-1.10093",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5211",
  "ui-addon-video-player": "static-1.9077",
  "ui-coaching-tips": "static-1.29558",
  "usage-tracker": "static-1.7775",
  "cms-field-types": "static-1.5266",
  "content-icons-ui": "static-1.2437",
  "integrations-lib": "static-1.17368",
  "customer-data-objects": "static-1.8148",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2078",
  "apollo-link-hub-http": "static-2.5040",
  "apollo-stack-hubspot": "static-3.98",
  "graphql": "static-1.93",
  "immer": "static-1.105",
  "immerable": "static-1.4595",
  "poll-commands": "static-1.3928",
  "ui-addon-iframeable": "static-1.9528",
  "video-components-external": "static-1.12388",
  "video-data-lib": "static-1.36046",
  "audio-components": "static-1.6534",
  "breeze-artifacts-sdk": "static-1.836",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30023",
  "FileManagerImages": "static-1.37946",
  "foundations-components-legacy": "static-1.1731",
  "html-to-image": "static-1.65",
  "redux-toolkit": "static-1.82",
  "salesImages": "static-1.708",
  "ui-universal-auth": "static-1.9677",
  "urlinator": "static-1.4968",
  "video-components": "static-1.14390",
  "video-embed": "static-1.36880",
  "ts-schema": "static-1.4383",
  "ContentData": "static-1.69497",
  "layout-data-lib": "static-1.10485",
  "react-dnd-compat": "static-1.5064",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.2001",
  "external-options-client-types": "static-1.4431",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6045",
  "hs-resources": "static-1.645",
  "inbound-db-properties-service-client": "static-1.4141",
  "NamespacedHubStyle": "static-2.9358",
  "growth-onboarding-confetti": "static-1.3515",
  "SharedI18nStrings": "static-1.187",
  "ui-addon-i18n": "static-1.11598",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5891",
  "magpie-types": "static-1.5351",
  "simple-logging-lib": "static-1.3505",
  "avatar-components": "static-1.2937",
  "customer-data-ui-utilities": "static-1.10285",
  "growth-onboarding-feedback-components": "static-1.7035",
  "flux-actions": "static-1.380",
  "hubspot-apollo-client": "static-1.5332",
  "integrations-error-boundary-lib": "static-1.14783",
  "integrations-tracking-lib": "static-1.6069",
  "laboratory-lib": "static-3.7602",
  "native-integrations-shared-strings": "static-1.8217",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10730",
  "unified-auth": "static-1.1191",
  "breeze-engine-chat-components": "static-1.1056",
  "breeze-engine-core": "static-1.1356",
  "ably": "static-2.2",
  "highlight.js": "static-1.90",
  "pulse": "static-1.1097",
  "navigation-messaging": "static-1.8442",
  "content-media-composition-data-lib": "static-1.13547",
  "content-media-compositions": "static-2.17554",
  "idb-keyval": "static-1.55",
  "media-bridge-lib": "static-1.19606",
  "nudge-client-utils": "static-1.3377",
  "unified-auth-core-lib": "static-1.1473",
  "social-insights-client-types": "static-1.22888",
  "advanced-menus-core": "static-1.15776",
  "advanced-menus-lib": "static-1.12538",
  "ExportDialog": "static-6.10824",
  "ui-memberships-settings-lib": "static-1.35133",
  "conditional-properties-service-client": "static-1.4102",
  "crm-pipelines-api-client-types": "static-1.4432",
  "event-emitter": "static-1.1414",
  "fdsr-migration-layer": "static-1.466",
  "framework-builder-read-service-client": "static-1.4323",
  "inbound-db-meta-service-client": "static-1.3767",
  "multi-currency-client-types": "static-1.3998",
  "foundations-components-test-utils": "static-1.6189",
  "reactive-lib": "static-1.1177",
  "trellis-migration-context": "static-1.31",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.791",
  "universal-page-editor-lib": "static-1.3462",
  "adobe-sign-auth-lib": "static-1.722",
  "ads-unified-auth-lib": "static-1.1867",
  "custom-vendor-connection-lib": "static-1.241",
  "google-sheets-integration-lib": "static-1.1289",
  "microsoft-drive-auth-lib": "static-1.449",
  "slack-ui-library": "static-1.10851",
  "surveymonkey-integration-lib": "static-1.823",
  "bend-plugin-pulse": "static-1.600",
  "fast-json-patch": "static-1.74",
  "nav-meta": "static-1.30752",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3134",
  "nudge-renderer-utils": "static-1.3453",
  "onboarding-tours": "static-1.17361",
  "whisper-core-api": "static-1.7597",
  "fsm": "static-1.4211",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15775",
  "simple-menus-lib": "static-1.17292",
  "settings-ui-lib": "static-1.12983",
  "persist-promise": "static-1.4158",
  "crm-record-cards-service-types": "static-1.3863",
  "framework-data-schema-resolvers": "static-1.7347",
  "location-customization-utils-lib": "static-1.10375",
  "getting-started-shared-tasks": "static-1.19519",
  "growth-data-modal": "static-1.6098",
  "growth-onboarding-next-action-utils": "static-1.2942",
  "navigation-components": "static-1.19115",
  "onboarding-tours-client": "static-1.5576",
  "onboarding-tours-utils": "static-1.1428",
  "ui-shepherd-tracker": "static-1.8111",
  "user-context": "static-1.5506",
  "react-flip-move": "static-1.82",
  "framework-data-schema-quick-fetch": "static-1.7252",
  "onboarding-data-sync-lib": "static-1.2804",
  "growth-onboarding-next-action-components": "static-1.2970",
  "user-context-client": "static-1.4963",
  "nest": "static-1.687",
  "getting-started-shared-tasks-store": "static-1.18637",
  "InboxConnectUtils": "static-4.15803",
  "meetings-connect-utils-lib": "static-1.8070",
  "onboarding-scopes": "static-1.6905"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30982",
  "emoji-mart": "/emoji-mart/static-3.6",
  "feedback-schema": "/feedback-schema/static-1.55560",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8491",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11945",
  "I18n": "/I18n/static-7.1703",
  "quartz": "/quartz/static-1.7632",
  "quartz-config": "/quartz-config/static-1.1410",
  "quartz-core": "/quartz-core/static-1.6851",
  "react-dlb": "/react-dlb/static-1.93",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.84",
  "reselect": "/reselect/static-3.16",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1075",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55547",
  "feedback-utils": "/feedback-utils/static-1.55551",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4916",
  "forms-utils-lib": "/forms-utils-lib/static-1.13299",
  "foundations-assets": "/foundations-assets/static-1.5339",
  "foundations-components": "/foundations-components/static-1.8706",
  "foundations-theming": "/foundations-theming/static-1.4942",
  "hub-http": "/hub-http/static-1.6662",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12252",
  "icons": "/icons/static-2.700",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4220",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1-use-beacon-keepalive-queue.3",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5645",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.516",
  "tinymce-plugins": "/tinymce-plugins/static-1.58467",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1273",
  "UIComponents": "/UIComponents/static-3.8891",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3909",
  "quartz-webpack": "/quartz-webpack/static-1.3856",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2658",
  "property-description-translator": "/property-description-translator/static-1.4272",
  "HeadJS": "/HeadJS/static-2.817",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3602",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.25",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.95",
  "jasmine": "/jasmine/static-4.4762",
  "jasmine-runner": "/jasmine-runner/static-1.6903",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-unrevert-default-instrumentation.4",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.904",
  "hubspotter-http": "/hubspotter-http/static-1.4965",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.601",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-unrevert-default-instrumentation.4",
  "quartz-auth": "/quartz-auth/static-1.1307",
  "quartz-head": "/quartz-head/static-1.1297",
  "quartz-i18n": "/quartz-i18n/static-1.1307",
  "quartz-routing": "/quartz-routing/static-1.1062",
  "quartz-test": "/quartz-test/static-1.1307",
  "quartz-tracking": "/quartz-tracking/static-1.1011",
  "trellis-components": "/trellis-components/static-1.3049",
  "ui-fonts": "/ui-fonts/static-1.1207",
  "usage-tracker-container": "/usage-tracker-container/static-1.7765",
  "usage-tracker-core": "/usage-tracker-core/static-1.7625",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.341",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7604",
  "reference-resolvers": "/reference-resolvers/static-1.8633",
  "sanitize-text": "/sanitize-text/static-1.8610",
  "PatternValidationJS": "/PatternValidationJS/static-1.3339",
  "ReduxMessenger": "/ReduxMessenger/static-2.10822",
  "outpost": "/outpost/static-1.4584",
  "rpc-client-utils": "/rpc-client-utils/static-1.5126",
  "sanitize": "/sanitize/static-1.4927",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4975",
  "floating-ui": "/floating-ui/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9878",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.98",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.3030",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3425",
  "foundations-theming-base": "/foundations-theming-base/static-1.3927",
  "stylex": "/stylex/static-1.46",
  "hs-locale-management": "/hs-locale-management/static-1.390",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.152",
  "web-vitals": "/web-vitals/static-1.19",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9975",
  "atom": "/atom/static-1.5529",
  "codemirror": "/codemirror/static-5.106",
  "content-assistance-lib": "/content-assistance-lib/static-1.8388",
  "ContentUtils": "/ContentUtils/static-1.69422",
  "data-token-picker": "/data-token-picker/static-1.17092",
  "file-manager-components": "/file-manager-components/static-1.24795",
  "FileManagerCore": "/FileManagerCore/static-1.40294",
  "FileManagerLib": "/FileManagerLib/static-1.40435",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8371",
  "hub-http-contrib": "/hub-http-contrib/static-1.3483",
  "interframe": "/interframe/static-3.5195",
  "layout-dnd-components": "/layout-dnd-components/static-1.13185",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12160",
  "property-translator": "/property-translator/static-1.5832",
  "react-codemirror": "/react-codemirror/static-1.11093",
  "react-colorpicker": "/react-colorpicker/static-2.10664",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8560",
  "rich-text-lib": "/rich-text-lib/static-1.20516",
  "tinymce-data": "/tinymce-data/static-1.41438",
  "tinymce-themes": "/tinymce-themes/static-1.57323",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10317",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5655",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16897",
  "bender-build-tools": "/bender-build-tools/static-1.3553",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10861",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10859",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5461",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1443",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.536",
  "chirp-fetch": "/chirp-fetch/static-1.2356",
  "stylex-utils": "/stylex-utils/static-1.170",
  "chatspot-core": "/chatspot-core/static-1.23708",
  "copilot-toolkit": "/copilot-toolkit/static-1.12103",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13483",
  "data-fetching-client": "/data-fetching-client/static-1.10093",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5211",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9077",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29558",
  "usage-tracker": "/usage-tracker/static-1.7775",
  "cms-field-types": "/cms-field-types/static-1.5266",
  "content-icons-ui": "/content-icons-ui/static-1.2437",
  "integrations-lib": "/integrations-lib/static-1.17368",
  "customer-data-objects": "/customer-data-objects/static-1.8148",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2078",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5040",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "graphql": "/graphql/static-1.93",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4595",
  "poll-commands": "/poll-commands/static-1.3928",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9528",
  "video-components-external": "/video-components-external/static-1.12388",
  "video-data-lib": "/video-data-lib/static-1.36046",
  "audio-components": "/audio-components/static-1.6534",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.836",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30023",
  "FileManagerImages": "/FileManagerImages/static-1.37946",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1731",
  "html-to-image": "/html-to-image/static-1.65",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "salesImages": "/salesImages/static-1.708",
  "ui-universal-auth": "/ui-universal-auth/static-1.9677",
  "urlinator": "/urlinator/static-1.4968",
  "video-components": "/video-components/static-1.14390",
  "video-embed": "/video-embed/static-1.36880",
  "ts-schema": "/ts-schema/static-1.4383",
  "ContentData": "/ContentData/static-1.69497",
  "layout-data-lib": "/layout-data-lib/static-1.10485",
  "react-dnd-compat": "/react-dnd-compat/static-1.5064",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.2001",
  "external-options-client-types": "/external-options-client-types/static-1.4431",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6045",
  "hs-resources": "/hs-resources/static-1.645",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4141",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9358",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3515",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11598",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5891",
  "magpie-types": "/magpie-types/static-1.5351",
  "simple-logging-lib": "/simple-logging-lib/static-1.3505",
  "avatar-components": "/avatar-components/static-1.2937",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10285",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7035",
  "flux-actions": "/flux-actions/static-1.380",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5332",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14783",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6069",
  "laboratory-lib": "/laboratory-lib/static-3.7602",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8217",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10730",
  "unified-auth": "/unified-auth/static-1.1191",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1056",
  "breeze-engine-core": "/breeze-engine-core/static-1.1356",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.90",
  "pulse": "/pulse/static-1.1097",
  "navigation-messaging": "/navigation-messaging/static-1.8442",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13547",
  "content-media-compositions": "/content-media-compositions/static-2.17554",
  "idb-keyval": "/idb-keyval/static-1.55",
  "media-bridge-lib": "/media-bridge-lib/static-1.19606",
  "nudge-client-utils": "/nudge-client-utils/static-1.3377",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1473",
  "social-insights-client-types": "/social-insights-client-types/static-1.22888",
  "advanced-menus-core": "/advanced-menus-core/static-1.15776",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12538",
  "ExportDialog": "/ExportDialog/static-6.10824",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35133",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4102",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4432",
  "event-emitter": "/event-emitter/static-1.1414",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.466",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4323",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3767",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3998",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6189",
  "reactive-lib": "/reactive-lib/static-1.1177",
  "trellis-migration-context": "/trellis-migration-context/static-1.31",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.791",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3462",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.722",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1867",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.241",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1289",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.449",
  "slack-ui-library": "/slack-ui-library/static-1.10851",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.823",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.600",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "nav-meta": "/nav-meta/static-1.30752",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3134",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3453",
  "onboarding-tours": "/onboarding-tours/static-1.17361",
  "whisper-core-api": "/whisper-core-api/static-1.7597",
  "fsm": "/fsm/static-1.4211",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15775",
  "simple-menus-lib": "/simple-menus-lib/static-1.17292",
  "settings-ui-lib": "/settings-ui-lib/static-1.12983",
  "persist-promise": "/persist-promise/static-1.4158",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3863",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7347",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10375",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19519",
  "growth-data-modal": "/growth-data-modal/static-1.6098",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2942",
  "navigation-components": "/navigation-components/static-1.19115",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5576",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1428",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8111",
  "user-context": "/user-context/static-1.5506",
  "react-flip-move": "/react-flip-move/static-1.82",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7252",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2804",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2970",
  "user-context-client": "/user-context-client/static-1.4963",
  "nest": "/nest/static-1.687",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18637",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15803",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8070",
  "onboarding-scopes": "/onboarding-scopes/static-1.6905"
}
};
